import { useState } from "react";

const faqs = [
  {
    q: "What is the driving range of the eTuatara 6 Seat Dual Motor?",
    a: "The eTuatara features a 26.5kWh lithium iron phosphate battery, offering an estimated driving range of up to 160km depending on terrain and usage."
  },
  {
    q: "Can the eTuatara be fitted with a fully enclosed cabin?",
    a: "Yes, the eTuatara can be fitted with a fully enclosed cabin, including a glass windscreen with wiper and washer, along with full or half doors."
  },
  {
    q: "Is the eTuatara suitable for farming and commercial use?",
    a: "Absolutely. The eTuatara is ideal for farming, tourism, and commercial transport where safe and comfortable passenger movement is required over demanding terrain."
  },
  {
    q: "How does the dual motor system improve performance?",
    a: "The dual motor configuration places one motor on each axle, eliminating driveline drag, improving traction, and delivering smoother, quieter performance."
  },
  {
    q: "What charging options are available?",
    a: "Each vehicle comes with its own charging cable and can be charged using a standard single-phase power outlet."
  }
];

const NZElectricDualFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="bg-white pb-[80px] px-6">
      <div className="max-w-[900px] mx-auto">
        {/* H2 */}
        <h2 className="text-center kuunari-bold text-[28px] md:text-[36px] mb-[40px]">
          You may still have questions
        </h2>

        {/* Accordion */}
        <div className="space-y-4">
          {faqs.map((item, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-md overflow-hidden"
            >
              <button
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
                className="w-full flex justify-between items-center px-6 py-4 text-left text-[16px] md:text-[18px] font-semibold text-[#333] bg-[#f9f9f9]"
              >
                {item.q}
                <span
                  className={`transform transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                >
                  ▼
                </span>
              </button>

              {openIndex === index && (
                <div className="px-6 py-4 text-[#666] text-[15px] leading-[26px] bg-white">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NZElectricDualFAQ;
